import { Panel, useReactFlow, getNodesBounds, getViewportForBounds } from '@xyflow/react'
import { createSyntheticDownload } from '@/utils'
import { useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import { toPng } from 'html-to-image'

function DownloadButton() {
    const { getNodes } = useReactFlow()
    const runsheet = useWireValue(store.currentRunsheet)
    
    const onClick = () => {
    // we calculate a transform for the nodes so that all nodes are visible
        // we then overwrite the transform of the `.react-flow__viewport` element
        // with the style option of the html-to-image library
        const nodesBounds = getNodesBounds(getNodes())
        const viewport = getViewportForBounds(nodesBounds)
        
        // eslint-disable-next-line no-restricted-globals
        toPng(document.querySelector('.react-flow__viewport'), {
            backgroundColor: '#1a365d',
            style: {
                transform: `translate(${viewport.x}px, ${viewport.y}px) scale(${viewport.zoom})`,
            },
        }).then(dataUrl => {
            createSyntheticDownload(dataUrl, 'image/png', `${runsheet?.name}-flowchart.png`)
        })
    }
    
    return (
        <Panel position="top-right">
            <button className="btn btn-primary" onClick={onClick}>
                Download Image
            </button>
        </Panel>
    )
}

export default DownloadButton